import React from 'react'

import { ROUTE_NAME, API_URL } from '../constants'

import Create from '../../components/Create'

import { FIELDS } from './Form'

const CreateAILayer = () => (
  <Create apiUrl={API_URL} routeName={ROUTE_NAME} fields={FIELDS} />
)

export default CreateAILayer
